import {ChangeDetectorRef, Injectable} from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {AuthProviderService} from "../../app-auth/services/auth-provider.service";
import {LogoutReason} from "../../app-auth/common/common.types";



@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthProviderService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((response: HttpErrorResponse) => {
      if (response.status === 401 || response.error.error === '401') {
        // auto logout if 401 response returned from api
        if (this.authenticationService.isAuthenticated()) {
            this.authenticationService.logout(LogoutReason.Automatic);
        }
      }

      const error = response.error.error_description || response.error.ExceptionMessage || response.statusText;
      return throwError(error);
    }));
  }
}

export const errorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true
};
